/**
 * Copies the content of a HTML component to the clipboard,
 * maintaining both rich and plain text versions.
 *
 * @param component HTML component, usually gotten from `this.$refs`.
 *   Example:
 *     <div ref="myDiv"></div>
 *     const myDiv = this.$refs.myDiv
 *     copyToClipboard(myDiv)
 */
export function copyComponentContentToClipboard(component, callback) {
  const rich = component.innerHTML
  const plain = component.textContent
  copyRichToClipboard(rich, plain, callback)
}

export function copyRichToClipboard(plain, rich, callback) {
  if (typeof ClipboardItem !== 'undefined') {
    // Uses Clipboard API. May not be fully supported by all browsers.
    // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API#browser_compatibility
    const types = {}
    if (plain) {
      const text = new Blob([plain], { type: 'text/plain' })
      types['text/plain'] = text
    }
    if (rich) {
      const html = new Blob([rich], { type: 'text/html' })
      types['text/html'] = html
    }
    const data = new ClipboardItem(types)
    navigator.clipboard.write([data]).then(() => {
      if (callback) callback()
    })
  } else {
    // Fallback using the deprecated `document.execCommand`. - FYI, this will happen in development
    // as ClipboardItem is not available in non-securce environments (http://).
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/execCommand#browser_compatibility
    const cb = (e) => {
      if (rich) e.clipboardData.setData('text/html', rich)
      if (plain) e.clipboardData.setData('text/plain', plain)
      e.preventDefault()
    }
    document.addEventListener('copy', cb)
    document.execCommand('copy')
    document.removeEventListener('copy', cb)

    if (callback) callback()
  }
}

function unsecuredCopyToClipboard(text) {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  document.execCommand('copy')
  document.body.removeChild(textArea)
}

export function copyToClipboard(content) {
  if (window.isSecureContext && navigator.clipboard) {
    navigator.clipboard.writeText(content)
  } else {
    unsecuredCopyToClipboard(content)
  }
}
